export default "__VITE_ASSET__BVd9ZSVE__"